<div class="tw-max-w-[920px] tw-mx-auto tw-my-[20px]">
    <div class="tw-flex tw-items-center tw-gap-2 tw-mb-3">
        <img
            src="/assets/images/matched-product/bulb.png"
            alt="bulb"
            class="tw-h-[25px] tw-min-w-[20px]"
        />
        <h2
            class="!tw-text-blue-900 !tw-text-[18px] !tw-mb-0 !tw-leading-[1.5]"
        >
            {{ "PRODUCT_MATCHING.CAN'T_FIND" | translate }}
        </h2>
    </div>
    <div
        class="tw-rounded-2xl tw-p-[40px] tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-4"
        [ngClass]="isDisabled ? 'tw-bg-gray-400' : 'tw-bg-[#95D1F3]'"
    >
        <div class="">
            <img
                src="/assets/images/matched-product/not-found.png"
                alt="Matched Product"
                class="tw-min-w-[120px]"
            />
        </div>
        <div class="tw-max-w-[480px] tw-text-center sm:tw-text-left">
            <h3 class="!tw-font-bold !tw-mb-3 !tw-text-[18px]">
                {{ "PRODUCT_MATCHING.FINANCIAL_ADVISORY" | translate }}
            </h3>
            <p>
                {{ "PRODUCT_MATCHING.FINANCIAL_ADVISORY_DESC" | translate }}
            </p>
        </div>
        <div class="">
            <button
                ga-event-id="fat_selection_no_product_match_click"
                ga-event-category="No Product Match Button"
                ga-event-label="FAT Selection Button"
                ga-track="track"
                (click)="onSelectFA()"
                [ngClass]="
                    isDisabled
                        ? 'tw-bg-gray-600'
                        : isSelected
                        ? 'tw-bg-blue-900 hover:tw-bg-blue-950'
                        : 'tw-bg-blue-600 hover:tw-bg-blue-600'
                "
                class="tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-5 tw-w-[225px]"
            >
                <mat-icon *ngIf="isSelected">check_circle_outline</mat-icon>
                {{
                    isSelected
                        ? ("PRODUCT_MATCHING.SELECTED" | translate)
                        : ("PRODUCT_MATCHING.SELECT" | translate)
                }}
            </button>
        </div>
    </div>
</div>
